import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableCell,
  TableBody,
  Paper,
  makeStyles
} from "@material-ui/core";

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

export default function ConfirmedCreativeList({
  data,
  isMultiAdvertiser,
  traffickedCreatives
}) {
  const classes = useStyles();

  const generateMultiRows = () => {
    let rowList = [];

    for (let advertiserId in traffickedCreatives) {
      for (let c of traffickedCreatives[advertiserId]) {
        rowList.push(
          <TableRow key={c.dcmCreative.id}>
            <TableCell component="th" scope="row">
              {advertiserId}
            </TableCell>
            <TableCell>{c.dcmCreative.name}</TableCell>
          </TableRow>
        );
      }
    }

    return rowList;
  };

  if (isMultiAdvertiser) {
    return (
      <div>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>GCM ID: </TableCell>
                <TableCell>Advertiser ID: </TableCell>
                <TableCell>Name: </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{generateMultiRows()}</TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  } else {
    return (
      <div>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>GCM ID: </TableCell>
                <TableCell>Advertiser ID: </TableCell>
                <TableCell>Name: </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.advertiserId}
                  </TableCell>
                  <TableCell>{row.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}
